export default __webpack_public_path__ + "images/indeed-flex-logo-login-83e5b6.svg";